import { CONVERSION_LABEL_ORDER, CONVERSION_LABEL_PHONE, GOOGLE_ADS_ID } from '@/config/tracking';
import { gtag, hasMarketingConsent } from '@/lib/consent';

const TAG_SCRIPT_ID = 'google-ads-gtag';
const SENT_ORDERS_KEY = 'bmg-ads-sent-orders';
const VAT_FACTOR = 1.25;

function isAdminPath(): boolean {
  return window.location.pathname === '/admin' || window.location.pathname.startsWith('/admin/');
}

function canTrack(): boolean {
  return GOOGLE_ADS_ID !== '' && hasMarketingConsent() && !isAdminPath();
}

export function loadGoogleAdsTag(): boolean {
  if (!canTrack()) return false;
  if (document.getElementById(TAG_SCRIPT_ID)) return true;
  gtag('js', new Date());
  gtag('config', GOOGLE_ADS_ID);
  const script = document.createElement('script');
  script.id = TAG_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GOOGLE_ADS_ID)}`;
  document.head.appendChild(script);
  return true;
}

function readSentOrders(): string[] {
  try {
    const parsed = JSON.parse(localStorage.getItem(SENT_ORDERS_KEY) || '[]');
    return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === 'string') : [];
  } catch {
    return [];
  }
}

function markOrderSent(orderNumber: string) {
  try {
    localStorage.setItem(SENT_ORDERS_KEY, JSON.stringify([...readSentOrders(), orderNumber].slice(-50)));
  } catch {
    // Storage blocked: nothing to persist.
  }
}

/** Sends the order conversion once per order number. totalInclVat is converted to an amount excl. VAT. */
export function trackOrderConversion(orderNumber: string, totalInclVat: number) {
  if (!CONVERSION_LABEL_ORDER || !orderNumber || !Number.isFinite(totalInclVat) || totalInclVat <= 0) return;
  if (readSentOrders().includes(orderNumber)) return;
  if (!loadGoogleAdsTag()) return;
  gtag('event', 'conversion', {
    send_to: `${GOOGLE_ADS_ID}/${CONVERSION_LABEL_ORDER}`,
    value: Math.round((totalInclVat / VAT_FACTOR) * 100) / 100,
    currency: 'NOK',
    transaction_id: orderNumber,
  });
  markOrderSent(orderNumber);
}

export function trackPhoneConversion() {
  if (!CONVERSION_LABEL_PHONE || !loadGoogleAdsTag()) return;
  gtag('event', 'conversion', { send_to: `${GOOGLE_ADS_ID}/${CONVERSION_LABEL_PHONE}` });
}
